import { createContext } from "react";
import { UserProfile } from "../types";

// user context shared globally
export const UserContext = createContext<{
  profile: UserProfile | null;
  isLoggedIn: boolean;
  setProfile: (profileToUpdate: UserProfile | null) => void;
}>({
  profile: null,
  isLoggedIn: false,
  // eslint-disable-next-line no-console
  setProfile: () => console.warn("No profile provider!"),
});
